/********************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2021, 2024
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} **/
import JavaKafkaCodeSnippet from './JavaKafkaCodeSnippet';

class KafkaConsoleConsumerCodeSnippet extends JavaKafkaCodeSnippet {
  // The only reason for using a byte deserializer is for schemas, which aren't supported by the console consumer
  // So use string instead to show the JSON representation
  getByteDeserializer() {
    return {
      deserializerClass: 'org.apache.kafka.common.serialization.StringDeserializer',
      deserializerType: 'String'
    };
  }
}

export default KafkaConsoleConsumerCodeSnippet;
